export default __webpack_public_path__ + "static/media/seeds.584397a2.jpg";